import { AfterViewInit, Directive, DoCheck, ElementRef, HostListener, Input, Renderer2, inject } from '@angular/core';

@Directive({
  selector: 'textarea[autoResize]',
  standalone: true
})
export class AutoResizeTextAreaDirective implements AfterViewInit, DoCheck {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);


  @Input() maxLines: number = 10;

  private previousValue: string = '';

  ngAfterViewInit(): void {
    this.adjust();
    this.previousValue = this.textarea.value;
  }

  ngDoCheck(): void {
    const currentValue = this.textarea.value;
    if (currentValue !== this.previousValue) {
      this.previousValue = currentValue;
      this.adjust();
    }
  }

  @HostListener('input')
  onInput(): void {
    this.adjust();
    this.previousValue = this.textarea.value;
  }

  private get textarea(): HTMLTextAreaElement {
    return this.el.nativeElement as HTMLTextAreaElement;
  }

  private adjust(): void {
    const textarea = this.el.nativeElement as HTMLTextAreaElement;

    // Reset height to calculate scrollHeight correctly
    this.renderer.setStyle(textarea, 'height', 'auto');

    // Calculate the maximum height (maxLines)
    const computedStyle = window.getComputedStyle(textarea);
    const lineHeight = parseFloat(computedStyle.lineHeight || '30'); // fallback default
    const maxHeight = lineHeight * this.maxLines;
    const scrollHeight = textarea.scrollHeight;

    // Set the height, capping it at maxHeight
    const newHeight = Math.min(scrollHeight, maxHeight);
    this.renderer.setStyle(textarea, 'height', `${newHeight}px`);
    // Show scrollbar if content exceeds maxHeight
    this.renderer.setStyle(textarea, 'overflow-y', scrollHeight > maxHeight ? 'auto' : 'hidden');
  }
}